export default __webpack_public_path__ + "static/media/2692.ddd6a4b1.png";